import { useEffect } from 'react';
import { X } from 'lucide-react';

export default function ReservationModal({ open, onClose }) {
  useEffect(function () {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return function () { document.body.style.overflow = ''; };
  }, [open]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/70 backdrop-blur-sm"
      onClick={onClose}
      data-testid="reservation-modal-overlay"
    >
      <div
        className="relative w-full max-w-3xl h-[85vh] mx-4 bg-[#0A0A0A] border border-[#C8A46A]/30 rounded-sm overflow-hidden"
        onClick={function (e) { e.stopPropagation(); }}
        data-testid="reservation-modal"
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-3 z-10 w-9 h-9 flex items-center justify-center bg-[#0A0A0A]/80 border border-[#C8A46A]/40 text-[#C8A46A] hover:bg-[#C8A46A] hover:text-[#0A0A0A] transition-colors rounded-sm"
          data-testid="reservation-modal-close"
        >
          <X className="w-5 h-5" />
        </button>
        <iframe
          src="https://reservatie.barbaarmiddelkerke.com"
          title="Reservatie BARBAAR"
          className="w-full h-full border-0"
          data-testid="reservation-iframe"
        />
      </div>
    </div>
  );
}
